export default __webpack_public_path__ + "static/media/G0130.Paediatric_Choking_GS_may22.1666265820000.5c256f14.jpg";